<template>
  <div class="container-fluid vertical-spacing">
    <div class="row">
      <div class="col-xs-12">
        <div class="product-title">
          <SfHeading
            :level="1"
            :description="product.Name"
            :title="product.Sku"
            class="sf-heading--left"
          />
        </div>
      </div>
      <div class="col-xs-12 col-md-6 m-tb-20">
        <SfSticky class="sticky">
          <div v-if="product.Pictures[0]" class="product-image">
            <ProductImage :src="pictureUrlPath(product.Pictures[0].ImageUrl)" :alt="product.Name" />
          </div>
        </SfSticky>
      </div>
      <div class="col-xs-12 col-md-6">
        <div v-if="product.ProductType != 'GroupedProduct'" class="product-add-to-cart">
          <Loader :loading="!productStock.Id">
            <ProductDetails
              class="product-simple-item"
              :isSimple="true"
              :product="simpleProduct"
            />
          </Loader>
        </div>
        <div v-else class="product-grouped-wrapper">
          <ProductFilters
            :productId="product.Id"
            :conditions="conditions"
            @filterUpdate="isFilteredProductsLoading = $event"
          />
          <Loader :loading="isFilteredProductsLoading">
            <ProductDetails
              class="product-grouped-item"
              v-for="simple in products"
              :key="simple.Product.Id + uuid()"
              :product="simple"
            />
            <div v-if="!products.length">
              <p>{{ $t('No products found.') }}</p>
              <p>{{ $t('Select equipment filter.')}}</p>
            </div>
          </Loader>
        </div>
        <div class="product-tabs">
          <SfTabs :open-tab="openTab" v-if="filteredTabs">
            <SfTab v-for="tab in filteredTabs" :key="tab.title" :title="tab.title">
              <span v-if="tab.content">{{ tab.content }}</span>
              <span v-else>{{ $t('No')}} {{ tab.title.toLowerCase() }} {{ $t('is avaible') }}</span>
            </SfTab>
          </SfTabs>
          <span class="no-description" v-else>{{ $t('No description.') }}</span>
        </div>
      </div>
      <div class="boards-interpretations">
        <SfTabs :open-tab="1" class="over-tabs">
          <SfTab v-if="boards.length" :title="$t('Boards')">
            <div class="col-xs-12">
              <ProductBoards :boards="boards" />
            </div>
          </SfTab>
          <SfTab v-if="!!interpretations" :title="$t('Interpretations')">
            <div class="col-xs-12">
              <ProductInterpretationsFlat :interpretations="[interpretations]" />
            </div>
          </SfTab>
        </SfTabs>
      </div>
    </div>
  </div>
</template>

<script>
import { v1 as uuidv1 } from 'uuid';
import {
  SfHeading,
  SfTabs,
  SfSticky,
} from '@storefront-ui/vue';
import cart from '@/modules/checkout/mixins/cart';
import { config, Loader } from '@/modules/core';
import ProductDetails from './ProductDetails.vue';
import ProductBoards from './ProductBoards.vue';
import ProductInterpretationsFlat from './ProductInterpretationsFlat.vue';
import ProductFilters from './ProductFilters.vue';
import ProductImage from './ProductImage.vue';

export default {
  name: 'ProductItem',
  mixins: [config, cart],
  components: {
    SfHeading,
    SfTabs,
    SfSticky,
    ProductBoards,
    ProductInterpretationsFlat,
    ProductDetails,
    ProductFilters,
    ProductImage,
    Loader,
  },
  data() {
    return {
      tabs: [
        {
          title: 'Description',
          content: this.product.FullDescription,
        },
      ],
      openTab: 1,
      isFilteredProductsLoading: false,
      simpleProduct: {
        Product: this.productStock,
      },
    };
  },
  computed: {
    filteredTabs() {
      return this.tabs.filter((tab) => tab.content);
    },
  },
  methods: {
    uuid() {
      return uuidv1();
    },
  },
  props: {
    boards: {
      type: Array,
      default: () => [],
    },
    interpretations: {
      type: Object,
      default: null,
    },
    conditions: {
      type: Array,
      required: true,
    },
    product: {
      type: Object,
      require: true,
    },
    productStock: {
      type: Object,
      require: true,
    },
    products: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.product-grouped-item {
  padding: 20px 10px;
  margin-bottom: 10px;
}

.active,
.product-grouped-item:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.sticky {
 --sticky-top: 80px;
}

.boards-interpretations {
  width: 100%;
}

</style>
